export default __webpack_public_path__ + "static/media/stylus-arm.d342fdeb.png";